import { BaseModel, IModelOptions } from './BaseModel';
import { IMultiNavigationData } from 'types/navigation';
import MemoryPatternConsistencyModel, { IPatternConsistencyGroupRow } from './MemoryPatternConsistencyModel';

export type IPatternConsistencyItemRow = {
  id: number;
  pattern: string;
  count: number;
  navigation_data: IMultiNavigationData;
  items: Array<{ translation_id: number; course_id: number; panel_id?: number }>;
  panel_ids?: number[];
  actions: boolean;
};

export default class MemoryPatternConsistencyItemsModel extends BaseModel<IPatternConsistencyItemRow> {
  dialectId = 0;
  parentModel: MemoryPatternConsistencyModel | null = null;
  currentGroupRow: IPatternConsistencyGroupRow | null = null;
  constructor(options: IModelOptions) {
    super(options);
    this.gridName = 'MemoryPatternConsistencyItems';
    this.getGridColumns();
  }

  setDialectId(id: number) {
    this.dialectId = id;
  }
  setParentModel(parent: MemoryPatternConsistencyModel) {
    this.parentModel = parent;
  }
  setCurrentGroup(row: IPatternConsistencyGroupRow) {
    this.currentGroupRow = row;
  }

  reset() {
    this.gridData = [] as any;
    this.gridDataUpdateRow = { type: 'none', data: null } as any;
    this.render();
  }

  setMembers(members: Array<IPatternConsistencyItemRow>) {
    this.gridData = (members || []).map((m) => ({ ...m }));
    this.render();
  }

  async getGridRow(itemId: number) {
    const row = (this.gridData as any[]).find((r) => r && r.id === itemId);
    return row || { id: itemId };
  }

  async applyMemberChange(memberId: number, editedPattern?: string) {
    try {
      const rows: any[] = Array.isArray(this.gridData) ? (this.gridData as any) : [];
      const idx = rows.findIndex((r) => r && r.id === memberId);
      if (idx !== -1) {
        const nextRow = { ...rows[idx], __changed: true } as any;
        if (editedPattern) nextRow.pattern = editedPattern;
        rows[idx] = nextRow;
        this.gridData = rows.slice();
      }
      this.render();
      await this.updateGridRow(memberId, 'update');

      const parent = this.parentModel;
      const currentGroup = this.currentGroupRow;
      if (!parent || !currentGroup || !Array.isArray(parent.gridData)) return;
      const gid = currentGroup.id;
      const gIdx = (parent.gridData as IPatternConsistencyGroupRow[]).findIndex((g) => g && g.id === gid);
      if (gIdx === -1) return;
      const grp = (parent.gridData as IPatternConsistencyGroupRow[])[gIdx];
      const members = Array.isArray(grp.members) ? grp.members.slice() : [];
      const mIdx = members.findIndex((m: any) => m && m.id === memberId);
      if (mIdx !== -1) {
        const nextMem = { ...members[mIdx], __changed: true } as any;
        if (editedPattern) nextMem.pattern = editedPattern;
        members[mIdx] = nextMem;
        (parent.gridData as any)[gIdx] = { ...grp, members };
        this.currentGroupRow = { ...currentGroup, members };
        try {
          parent.render();
        } catch {}
      }
    } catch (e) {
      console.error('[PatternConsistency] applyMemberChange() failed', e);
    }
  }
}
